import { useSelector } from 'react-redux';
import { ApplicationState } from '../../store';
import { useAuth } from './useAuth';
import { useApiInstance } from './useApiInstance';
import { EndpointsMvp } from './enum';

export const useWishlistService = () => {
  const { getHeaders } = useAuth();
  const commerceApi = useApiInstance();
  const { emitterId, receiverId } = useSelector(
    (state: ApplicationState) => state.longSteelShoppingCart
  );

  const addToWishlist = async (sku: string): Promise<boolean> => {
    try {
      const response = await commerceApi.post<boolean>(
        EndpointsMvp.WISHLIST_ADD(emitterId, receiverId),
        { sku },
        { headers: getHeaders({ withCommerceToken: true }) }
      );
      return response.data === true;
    } catch {
      return false;
    }
  };

  const removeFromWishlist = async (sku: string): Promise<boolean> => {
    try {
      const response = await commerceApi.delete<boolean>(
        EndpointsMvp.WISHLIST_REMOVE(sku, emitterId, receiverId),
        { headers: getHeaders({ withCommerceToken: true }) }
      );
      return response.data === true;
    } catch {
      return false;
    }
  };

  return { addToWishlist, removeFromWishlist };
};
